<template>
  <div
    @mouseenter="onMouseenter"
    @mouseleave="onMouseleave"
    :class="{'u-wrapper-panel': isAbolute}"
    :style="{transform: isHor ? 'translate3d( ' + (-currentScroll) + 'px, 0, 0)' : 'translate3d( 0, ' + (-currentScroll) + 'px, 0)'}"
  >
    <div ref="container">
      <slot></slot>
    </div>
  </div>
</template>

<script>
import { VirtualScroll } from '@/utils/VirtualScroll'
import { clamp } from '@/utils/Maths'

export default {

  props: {
    isActive: {
      type: Boolean,
      default: false
    },
    smooth: {
      type: Number,
      default: .08
    },
    callback: {
      type: Function,
      default: ()=>{return}
    },
    isAbolute: {
      type: Boolean,
      default: false
    },
    isHor: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      currentScroll: 0,
      isMouseover: false
    }
  },

  created() {
    this.easing = null
    this.maxScroll = 0
    this.scroll = 0
    this.winHeight = 0
  },

  mounted() {
    this.virtualScroll = new VirtualScroll({ clamp: {min: 0} })
    this.virtualScroll.onSmoothScroll(this.onScroll)
    setTimeout( this.onResize, 200 )
  },

  beforeDestroy(){
    clearTimeout(this.setTimeout)
    this.virtualScroll.onDestroy()
  },

  methods: {
    onResize() {
      if (!this.$el || !this.$refs.container) { return }

      if (!this.isHor) {
        this.wrapperHeight = this.$el.offsetHeight
        this.itemHeight = this.$refs.container.offsetHeight
        this.maxScroll = this.itemHeight - this.wrapperHeight
      }
      else {
        this.wrapperWidth = this.$el.offsetWidth
        this.itemWidth = this.$refs.container.offsetWidth
        this.maxScroll = this.itemWidth - this.wrapperWidth
      }

      this.virtualScroll.clamp.max = this.maxScroll
      this.maxScroll = this.maxScroll < 0 ? 0 : this.maxScroll

      this.setTimeout = setTimeout( this.onResize, 1000 )
    },

    onScroll({ value }) {
      if( !this.isActive ) { return }

      this.currentScroll = value
    },

    onMouseenter() {
      this.isMouseover = true
    },

    onMouseleave() {
      this.isMouseover = false
    }
  },

  watch: {
    isActive () {
      this.virtualScroll.active = this.isMouseover && this.isActive
    },
    isMouseover () {
      this.virtualScroll.active = this.isMouseover && this.isActive
    }
  }
}
</script>